<template>
    <div class="mb-3">
        <b-card no-body v-bind="$attrs">
            <b-card-header class="p-1 pl-3">
                <b-row>
                    <b-col cols="auto">
                        <h4>{{ title }}</h4>
                    </b-col>
                    <b-col cols="auto" class="ml-auto">
                        <slot name="header" />
                        <slot v-if="show && ready" name="header-show" />
                        <slot v-else name="header-hide" />
                        <b-button-group size="sm">
                            <b-button
                                v-if="(read && !show) || alwaysShow"
                                variant="dark"
                                @click="load()"
                            >
                                {{ read }}
                            </b-button>
                            <b-button
                                v-if="read && !write && show"
                                variant="dark"
                                @click="show = false"
                            >
                                Hide
                            </b-button>
                            <RemoveButton
                                v-if="remove && show"
                                @click="removeAction()"
                            />
                            <b-button
                                v-if="remove && show"
                                variant="danger"
                                @click="show = false"
                            >
                                Cancel
                            </b-button>
                            <b-button
                                v-if="(write && show) || alwaysShow"
                                variant="success"
                                @click="save()"
                            >
                                {{ write }}
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body
                v-if="(show || alwaysShow) && ready && !saving"
                class="p-2 p-sm-3"
            >
                <slot />
            </b-card-body>
            <b-card-body v-if="show && !ready">
                <Spinner text="Loading" />
            </b-card-body>
            <b-card-body v-if="show && saving">
                <Spinner text="Saving" />
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import Spinner from '@/components/general/spinner'
    import RemoveButton from '@/components/form/removebutton'

    export default {
        props: {
            title: String,
            read: String,
            write: String,
            remove: String,
            alwaysShow: Boolean
        },
        data() {
            return {
                show: this.alwaysShow,
                ready: false,
                saving: false
            }
        },
        methods: {
            async load() {
                this.show = true
                this.ready = false
                await this.$listeners.read()
                this.ready = true
            },
            async save() {
                this.saving = true
                await this.$listeners.write().catch(error => {
                    this.$bvToast.toast(error, {
                        title: 'Error',
                        variant: 'warning'
                    })
                })
                this.saving = false
                this.show = false
            },
            async removeAction() {
                this.saving = true
                await this.$listeners.remove().catch(error => {
                    this.$bvToast.toast(error, {
                        title: 'Error',
                        variant: 'warning'
                    })
                })
                this.saving = false
                this.show = false
            }
        },
        created() {
            if (this.alwaysShow) this.load()
        },
        components: {
            RemoveButton,
            Spinner
        }
    }
</script>

<style scoped>
</style>